/**
Author - Babajan
Git - https://www.github.com/babajanpatan
**/

import React, {useState, useEffect} from "react";
import SafeLink from "components/commons/SafeLink";
import styled from "styled-components";

import {colors} from "nxtconstants";


import {
  WealthyEnv
} from "helpers";

const NewsLetterShareButtons = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  const faceBookShareLink = `${WealthyEnv.FACEBOOK_SHARE_LINK}=${url}?utm_source=Facebook&utm_medium=Share&
  utm_campaign=New%20Blog%20Post`;
  const twitterShareLink = `${WealthyEnv.TWITTER_SHARE_LINK}=${url}?utm_source=Twitter&utm_medium=Share&
  utm_campaign=New%20Blog%20Post&via=wealthy_india`;
  const linkedInShareLink = `${WealthyEnv.LINKEDIN_SHARE_LINK}=${url}?utm_source=LinkedIn&utm_medium=Share&
  utm_campaign=New%20Blog%20Post`;
  const whatsappShareLink = `${WealthyEnv.WHATSAPP_SHARE_LINK}?text=${url}?utm_source=WhatsApp&utm_medium=Share&
  utm_campaign=New%20Blog%20Post`;

  const faceBookIcon = `${WealthyEnv.GREY_MATTER_CDN_URL}/facebook.png`;
  const twitterIcon = `${WealthyEnv.CDN_URL}/articles/x-icon.png`;
  const linkedInIcon = `${WealthyEnv.CDN_URL}/articles/linkedin-share-buttons.png`;
  const whatsappIcon = `${WealthyEnv.CDN_URL}/articles/whatsapp-darkgreen-icon.png`;

  const iconArray = [
    {
      id: 1,
      shareLink: faceBookShareLink,
      alt: "facebook",
      icon: faceBookIcon
    },
    {
      id: 2,
      shareLink: twitterShareLink,
      alt: "twitter",
      icon: twitterIcon
    },
    {
      id: 3,
      shareLink: linkedInShareLink,
      alt: "linkedin",
      icon: linkedInIcon
    },
    {
      id: 4,
      shareLink: whatsappShareLink,
      alt: "whatsapp",
      icon: whatsappIcon
    }
  ];

  return (
    <SocialIconsContainer>
      <SocialShareHeading>Share this edition</SocialShareHeading>
      <SocialSharSubHeading>Just use these easy share buttons</SocialSharSubHeading>
      <SocialIcons>
        {
          iconArray.map((socialIcon) => (
            <SafeLink
              className="share-buttons__link"
              href={socialIcon.shareLink}
              key={socialIcon.id}
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt={socialIcon.alt}
                className="share-buttons__image"
                loading="lazy"
                src={socialIcon.icon}
              />
            </SafeLink>
          ))
        }
      </SocialIcons>


    </SocialIconsContainer>
  );
};

const SocialIconsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1000;
`;

const SocialShareHeading = styled.h3`
   font-size: 2.4rem;
   font-family: MavenPro;
  color: ${colors.black};
  font-weight: bolder;

`;

const SocialSharSubHeading = styled.h4`
   font-size: 1.6rem;
   font-family: MavenPro;
   color: ${colors.textGrey};
   font-weight: lighter;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 2rem 0rem;

  .share-buttons__link {
    width: 5rem;
    cursor: pointer;
  }

  .share-buttons__image {
    width: 100%;
  }
`;

export default NewsLetterShareButtons;

